import React from "react";
import { PAGE_SIZE } from "../../services";
import { Grid, CircularProgress, IconButton } from "@material-ui/core";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";
import { PageSizeFilter } from "./PageSizeFilter";
export const Pager = ({ complaintsState, isTopPager, navigate, params }) => {
    const { loadingState, data: pagedResponse } = complaintsState;
    const { page = 0, totalPages = 1, pageSize = PAGE_SIZE, totalCount } = pagedResponse;
    const shouldRender = isTopPager || loadingState === "LOADED" || loadingState === "LOADING";
    if (!shouldRender) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", null,
        React.createElement(Grid, { container: true, direction: "row", justify: "flex-end", alignItems: "center", spacing: 4, style: { marginTop: 0 }, className: "Pager" },
            isTopPager && loadingState === "LOADING" && (React.createElement(Grid, { item: true },
                React.createElement(CircularProgress, { size: 24, color: "secondary" }))),
            React.createElement(Grid, { item: true, className: "PagerSectionRecordCount" },
                totalCount,
                " Records"),
            React.createElement(Grid, { item: true, className: "PagerSectionPage" },
                React.createElement("p", null,
                    "Showing page ",
                    page + 1,
                    " of ",
                    React.createElement("span", { "data-test": "total-pages" }, totalPages))),
            React.createElement(Grid, { item: true, className: "PagerSectionPageSize" },
                "Cases per page:",
                pageSize && React.createElement(PageSizeFilter, { navigate: navigate, params: params })),
            React.createElement(Grid, { item: true, className: "PagerSectionButtons" },
                React.createElement(IconButton, { onClick: _ => navigate({ page: undefined }), disabled: page === 0, "data-test": "pager-first", style: {
                        maxWidth: "50px",
                    } },
                    React.createElement(ChevronLeft, { style: {
                            position: "relative",
                            left: "9px",
                        } }),
                    React.createElement(ChevronLeft, { style: {
                            position: "relative",
                            left: "-9px",
                        } })),
                React.createElement(IconButton, { onClick: _ => navigate({ page: page - 1 || undefined }), disabled: page === 0, "data-test": "pager-prev" },
                    React.createElement(ChevronLeft, null)),
                React.createElement(IconButton, { onClick: _ => navigate({ page: page + 1 }), disabled: page === totalPages - 1, "data-test": "pager-next" },
                    React.createElement(ChevronRight, null)),
                React.createElement(IconButton, { onClick: _ => navigate({ page: totalPages - 1 }), disabled: page === totalPages - 1, "data-test": "pager-last", style: {
                        maxWidth: "50px",
                    } },
                    React.createElement(ChevronRight, { style: {
                            position: "relative",
                            left: "9px",
                        } }),
                    React.createElement(ChevronRight, { style: {
                            position: "relative",
                            left: "-9px",
                        } }))))));
};
